import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { parse } from '../../../util/urlHelpers';
import { closestCategoryHome } from '../../../util/categorySuggestions';
import { getCategoryUrl } from '../../../util/categoryLandingHelpers';

import css from './NoSearchResultsMaybe.module.css';

/**
 * Designed zero-results card (measured from the prototype's empty search
 * state): centered bordered card — Hanken title with the quoted term, one
 * line of copy (the closest category home becomes a live green link when the
 * keywords match one), a green "Browse all categories" CTA to the landing
 * page, plus the ledger-kept reset / create-listing escape hatches as quiet
 * links.
 */
const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  const keywords = parse(location.search || '')?.keywords;
  const closestHome = keywords ? closestCategoryHome(keywords) : null;
  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <h2 className={css.title}>
        {keywords ? (
          <FormattedMessage id="SearchPage.noResultsKeywords" values={{ keywords }} />
        ) : (
          <FormattedMessage id="SearchPage.noResults" />
        )}
      </h2>
      <p className={css.copy}>
        {closestHome ? (
          <FormattedMessage
            id="SearchPage.zeroResultsCopyWithHome"
            values={{
              home: (
                <Link className={css.homeLink} to={getCategoryUrl(closestHome.id)}>
                  {closestHome.name}
                </Link>
              ),
            }}
          />
        ) : (
          <FormattedMessage id="SearchPage.zeroResultsCopy" />
        )}
      </p>
      <NamedLink name="LandingPage" className={css.browseAllButton}>
        <FormattedMessage id="SearchPage.browseAllCategories" />
      </NamedLink>
      <div className={css.escapeRow}>
        {hasSearchParams ? (
          <button className={css.escapeLink} onClick={e => resetAll(e)}>
            <FormattedMessage id="SearchPage.resetAllFilters" />
          </button>
        ) : null}
        <NamedLink className={css.escapeLink} name="NewListingPage">
          <FormattedMessage id="SearchPage.createListing" />
        </NamedLink>
      </div>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
